import { takeEvery, put, call, SagaReturnType } from 'redux-saga/effects';
import { PatientActions } from 'src/redux/actions/constant';
import patientService from 'src/services/apiServices/patientService';

const {
  GET_REQUEST_ENTERPRISE_PHYSICIAN,
  GET_SUCCESS_ENTERPRISE_PHYSICIAN,
  GET_FAILURE_ENTERPRISE_PHYSICIAN,
  GET_FAILURE_ENTERPRISE_LOADER,
} = PatientActions;

function* getAllPhysician(payload: any): SagaReturnType<any> {
  try {
    yield put({ type: GET_FAILURE_ENTERPRISE_LOADER });
    const response = yield call(patientService.getAllPhysician, payload?.payload);
    if (response?.status === 200) {
      yield put({
        type: GET_SUCCESS_ENTERPRISE_PHYSICIAN,
        payload: response.data,
      });
    } else {
      throw { ...response.data, statusCode: response?.status };
    }
  } catch (error) {
    yield put({ type: GET_FAILURE_ENTERPRISE_PHYSICIAN, payload: error });
  } finally {
    // yield put({ type: LOADER_OFF });
  }
}

function* getAllPhysicianSaga() {
  yield takeEvery(GET_REQUEST_ENTERPRISE_PHYSICIAN, getAllPhysician);
}

export default getAllPhysicianSaga;
